/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  DutyRosterPeriodDto,
  GetPersonalMonthReportPrintParams,
  GetReleasePeriodsParams,
  RapportsGetDutyRosterPrintParams
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetMaxDateUrl = () => {




  return `/api/Rapports/GetMaxDate`
}

export const getMaxDate = async ( options?: Parameters<typeof customInstance>[1]): Promise<string> => {

  return customInstance<string>(getGetMaxDateUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMaxDateQueryKey = () => {
    return [
    `/api/Rapports/GetMaxDate`
    ] as const;
    }


export const getGetMaxDateQueryOptions = <TData = Awaited<ReturnType<typeof getMaxDate>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMaxDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMaxDateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMaxDate>>> = ({ signal }) => getMaxDate({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMaxDate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMaxDateQueryResult = NonNullable<Awaited<ReturnType<typeof getMaxDate>>>
export type GetMaxDateQueryError = ErrorType<unknown>


export function useGetMaxDate<TData = Awaited<ReturnType<typeof getMaxDate>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMaxDate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMaxDate>>,
          TError,
          Awaited<ReturnType<typeof getMaxDate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMaxDate<TData = Awaited<ReturnType<typeof getMaxDate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMaxDate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMaxDate>>,
          TError,
          Awaited<ReturnType<typeof getMaxDate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMaxDate<TData = Awaited<ReturnType<typeof getMaxDate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMaxDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMaxDate<TData = Awaited<ReturnType<typeof getMaxDate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMaxDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMaxDateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMaxDateSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMaxDate>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMaxDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMaxDateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMaxDate>>> = ({ signal }) => getMaxDate({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMaxDate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMaxDateSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMaxDate>>>
export type GetMaxDateSuspenseQueryError = ErrorType<unknown>


export function useGetMaxDateSuspense<TData = Awaited<ReturnType<typeof getMaxDate>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMaxDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMaxDateSuspense<TData = Awaited<ReturnType<typeof getMaxDate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMaxDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMaxDateSuspense<TData = Awaited<ReturnType<typeof getMaxDate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMaxDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMaxDateSuspense<TData = Awaited<ReturnType<typeof getMaxDate>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMaxDate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMaxDateSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonalMonthReportPrintUrl = (params?: GetPersonalMonthReportPrintParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Rapports/GetPersonalMonthReportPrint?${stringifiedParams}` : `/api/Rapports/GetPersonalMonthReportPrint`
}

export const getPersonalMonthReportPrint = async (params?: GetPersonalMonthReportPrintParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getGetPersonalMonthReportPrintUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPersonalMonthReportPrintQueryKey = (params?: GetPersonalMonthReportPrintParams,) => {
    return [
    `/api/Rapports/GetPersonalMonthReportPrint`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPersonalMonthReportPrintQueryOptions = <TData = Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError = ErrorType<unknown>>(params?: GetPersonalMonthReportPrintParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonalMonthReportPrintQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>> = ({ signal }) => getPersonalMonthReportPrint(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonalMonthReportPrintQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>>
export type GetPersonalMonthReportPrintQueryError = ErrorType<unknown>


export function useGetPersonalMonthReportPrint<TData = Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonalMonthReportPrintParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonalMonthReportPrint>>,
          TError,
          Awaited<ReturnType<typeof getPersonalMonthReportPrint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonalMonthReportPrint<TData = Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError = ErrorType<unknown>>(
 params?: GetPersonalMonthReportPrintParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonalMonthReportPrint>>,
          TError,
          Awaited<ReturnType<typeof getPersonalMonthReportPrint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonalMonthReportPrint<TData = Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError = ErrorType<unknown>>(
 params?: GetPersonalMonthReportPrintParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonalMonthReportPrint<TData = Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError = ErrorType<unknown>>(
 params?: GetPersonalMonthReportPrintParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonalMonthReportPrintQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonalMonthReportPrintSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError = ErrorType<unknown>>(params?: GetPersonalMonthReportPrintParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonalMonthReportPrintQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>> = ({ signal }) => getPersonalMonthReportPrint(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPersonalMonthReportPrintSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>>
export type GetPersonalMonthReportPrintSuspenseQueryError = ErrorType<unknown>


export function useGetPersonalMonthReportPrintSuspense<TData = Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonalMonthReportPrintParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonalMonthReportPrintSuspense<TData = Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError = ErrorType<unknown>>(
 params?: GetPersonalMonthReportPrintParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonalMonthReportPrintSuspense<TData = Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError = ErrorType<unknown>>(
 params?: GetPersonalMonthReportPrintParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonalMonthReportPrintSuspense<TData = Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError = ErrorType<unknown>>(
 params?: GetPersonalMonthReportPrintParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonalMonthReportPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonalMonthReportPrintSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRapportsGetDutyRosterPrintUrl = (params?: RapportsGetDutyRosterPrintParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Rapports/GetDutyRosterPrint?${stringifiedParams}` : `/api/Rapports/GetDutyRosterPrint`
}

export const rapportsGetDutyRosterPrint = async (params?: RapportsGetDutyRosterPrintParams, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

  return customInstance<void>(getRapportsGetDutyRosterPrintUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRapportsGetDutyRosterPrintQueryKey = (params?: RapportsGetDutyRosterPrintParams,) => {
    return [
    `/api/Rapports/GetDutyRosterPrint`, ...(params ? [params] : [])
    ] as const;
    }


export const getRapportsGetDutyRosterPrintQueryOptions = <TData = Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError = ErrorType<unknown>>(params?: RapportsGetDutyRosterPrintParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRapportsGetDutyRosterPrintQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>> = ({ signal }) => rapportsGetDutyRosterPrint(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RapportsGetDutyRosterPrintQueryResult = NonNullable<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>>
export type RapportsGetDutyRosterPrintQueryError = ErrorType<unknown>


export function useRapportsGetDutyRosterPrint<TData = Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError = ErrorType<unknown>>(
 params: undefined |  RapportsGetDutyRosterPrintParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>,
          TError,
          Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRapportsGetDutyRosterPrint<TData = Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError = ErrorType<unknown>>(
 params?: RapportsGetDutyRosterPrintParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>,
          TError,
          Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRapportsGetDutyRosterPrint<TData = Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError = ErrorType<unknown>>(
 params?: RapportsGetDutyRosterPrintParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRapportsGetDutyRosterPrint<TData = Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError = ErrorType<unknown>>(
 params?: RapportsGetDutyRosterPrintParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRapportsGetDutyRosterPrintQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRapportsGetDutyRosterPrintSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError = ErrorType<unknown>>(params?: RapportsGetDutyRosterPrintParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRapportsGetDutyRosterPrintQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>> = ({ signal }) => rapportsGetDutyRosterPrint(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type RapportsGetDutyRosterPrintSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>>
export type RapportsGetDutyRosterPrintSuspenseQueryError = ErrorType<unknown>


export function useRapportsGetDutyRosterPrintSuspense<TData = Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError = ErrorType<unknown>>(
 params: undefined |  RapportsGetDutyRosterPrintParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRapportsGetDutyRosterPrintSuspense<TData = Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError = ErrorType<unknown>>(
 params?: RapportsGetDutyRosterPrintParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRapportsGetDutyRosterPrintSuspense<TData = Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError = ErrorType<unknown>>(
 params?: RapportsGetDutyRosterPrintParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useRapportsGetDutyRosterPrintSuspense<TData = Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError = ErrorType<unknown>>(
 params?: RapportsGetDutyRosterPrintParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof rapportsGetDutyRosterPrint>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRapportsGetDutyRosterPrintSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetReleasePeriodsUrl = (params?: GetReleasePeriodsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Rapports/GetReleasePeriods?${stringifiedParams}` : `/api/Rapports/GetReleasePeriods`
}

export const getReleasePeriods = async (params?: GetReleasePeriodsParams, options?: Parameters<typeof customInstance>[1]): Promise<DutyRosterPeriodDto[]> => {

  return customInstance<DutyRosterPeriodDto[]>(getGetReleasePeriodsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReleasePeriodsQueryKey = (params?: GetReleasePeriodsParams,) => {
    return [
    `/api/Rapports/GetReleasePeriods`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetReleasePeriodsQueryOptions = <TData = Awaited<ReturnType<typeof getReleasePeriods>>, TError = ErrorType<unknown>>(params?: GetReleasePeriodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleasePeriods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReleasePeriodsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleasePeriods>>> = ({ signal }) => getReleasePeriods(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReleasePeriods>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReleasePeriodsQueryResult = NonNullable<Awaited<ReturnType<typeof getReleasePeriods>>>
export type GetReleasePeriodsQueryError = ErrorType<unknown>


export function useGetReleasePeriods<TData = Awaited<ReturnType<typeof getReleasePeriods>>, TError = ErrorType<unknown>>(
 params: undefined |  GetReleasePeriodsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleasePeriods>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReleasePeriods>>,
          TError,
          Awaited<ReturnType<typeof getReleasePeriods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReleasePeriods<TData = Awaited<ReturnType<typeof getReleasePeriods>>, TError = ErrorType<unknown>>(
 params?: GetReleasePeriodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleasePeriods>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReleasePeriods>>,
          TError,
          Awaited<ReturnType<typeof getReleasePeriods>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReleasePeriods<TData = Awaited<ReturnType<typeof getReleasePeriods>>, TError = ErrorType<unknown>>(
 params?: GetReleasePeriodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleasePeriods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReleasePeriods<TData = Awaited<ReturnType<typeof getReleasePeriods>>, TError = ErrorType<unknown>>(
 params?: GetReleasePeriodsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleasePeriods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReleasePeriodsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetReleasePeriodsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getReleasePeriods>>, TError = ErrorType<unknown>>(params?: GetReleasePeriodsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePeriods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReleasePeriodsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleasePeriods>>> = ({ signal }) => getReleasePeriods(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePeriods>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetReleasePeriodsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getReleasePeriods>>>
export type GetReleasePeriodsSuspenseQueryError = ErrorType<unknown>


export function useGetReleasePeriodsSuspense<TData = Awaited<ReturnType<typeof getReleasePeriods>>, TError = ErrorType<unknown>>(
 params: undefined |  GetReleasePeriodsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePeriods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReleasePeriodsSuspense<TData = Awaited<ReturnType<typeof getReleasePeriods>>, TError = ErrorType<unknown>>(
 params?: GetReleasePeriodsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePeriods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReleasePeriodsSuspense<TData = Awaited<ReturnType<typeof getReleasePeriods>>, TError = ErrorType<unknown>>(
 params?: GetReleasePeriodsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePeriods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReleasePeriodsSuspense<TData = Awaited<ReturnType<typeof getReleasePeriods>>, TError = ErrorType<unknown>>(
 params?: GetReleasePeriodsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePeriods>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReleasePeriodsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetReleasePeriodsForTileUrl = () => {




  return `/api/Rapports/GetReleasePeriodsForTile`
}

export const getReleasePeriodsForTile = async ( options?: Parameters<typeof customInstance>[1]): Promise<DutyRosterPeriodDto[]> => {

  return customInstance<DutyRosterPeriodDto[]>(getGetReleasePeriodsForTileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetReleasePeriodsForTileQueryKey = () => {
    return [
    `/api/Rapports/GetReleasePeriodsForTile`
    ] as const;
    }


export const getGetReleasePeriodsForTileQueryOptions = <TData = Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReleasePeriodsForTileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleasePeriodsForTile>>> = ({ signal }) => getReleasePeriodsForTile({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReleasePeriodsForTileQueryResult = NonNullable<Awaited<ReturnType<typeof getReleasePeriodsForTile>>>
export type GetReleasePeriodsForTileQueryError = ErrorType<unknown>


export function useGetReleasePeriodsForTile<TData = Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReleasePeriodsForTile>>,
          TError,
          Awaited<ReturnType<typeof getReleasePeriodsForTile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReleasePeriodsForTile<TData = Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReleasePeriodsForTile>>,
          TError,
          Awaited<ReturnType<typeof getReleasePeriodsForTile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReleasePeriodsForTile<TData = Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReleasePeriodsForTile<TData = Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReleasePeriodsForTileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetReleasePeriodsForTileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReleasePeriodsForTileQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleasePeriodsForTile>>> = ({ signal }) => getReleasePeriodsForTile({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetReleasePeriodsForTileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getReleasePeriodsForTile>>>
export type GetReleasePeriodsForTileSuspenseQueryError = ErrorType<unknown>


export function useGetReleasePeriodsForTileSuspense<TData = Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReleasePeriodsForTileSuspense<TData = Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReleasePeriodsForTileSuspense<TData = Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReleasePeriodsForTileSuspense<TData = Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getReleasePeriodsForTile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReleasePeriodsForTileSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






